// extracted by mini-css-extract-plugin
module.exports = {"root":"TestimonialsBlock_root__Gxz8x"};